import React from 'react';
import { hot } from 'react-hot-loader';
import ButtonElement from '../../Elements/Button/Button';
import { purifier } from '../../../utils/dom';
import { imageSizeTranslation } from '../../../utils/image';
import { cleanInternalLinks } from '../../../utils/string';
import s from './Image.scss';

const Image = ({ content = {}, attrs = {}, column = 'full', extraProps = null, isFlexGroup = false }) => {
	const styles = {};
	if (attrs.width) styles.maxWidth = `${attrs.width}px`;

	return (
		<figure className={[s.image, (isFlexGroup ? s.image__flexGroup : null)].join(' ')} style={styles}>
			<ButtonElement type="link" location={cleanInternalLinks(attrs?.href)} noStyling>
				<img className={s.image_image} {...imageSizeTranslation(column, content.image)} {...extraProps} />
				{ content.caption && <figcaption className={s.image_caption} dangerouslySetInnerHTML={{ __html: purifier(content.caption.rawText) }} /> }
			</ButtonElement>
		</figure>
	);
};

export default hot(module)(Image);
